/**
 * Alternative usernames offered when the one a person typed is already taken (case-insensitively:
 * "@Jake" and "@jake" are the same account). Pure — the caller checks which candidates are free.
 * Every candidate is a valid canonical username (3-20 chars of a-z, 0-9, _) and differs from `base`.
 * `random` is injectable so the output is deterministic in tests.
 */
import { USERNAME_RE, normalizeUsername } from './username'

const MAX_LEN = 20

/** Keep the stem short enough that a suffix still fits in 20 characters. */
function stem(base: string, room: number): string {
  return base.slice(0, Math.max(1, MAX_LEN - room)).replace(/_+$/, '')
}

export function usernameCandidates(rawBase: string, random: () => number = Math.random, max = 12): string[] {
  const base = normalizeUsername(rawBase).replace(/[^a-z0-9_]/g, '')
  if (!base) return []
  const year = String(new Date().getFullYear()).slice(-2)
  const digits = (n: number) => String(Math.floor(random() * 10 ** n)).padStart(n, '0')
  const raw: string[] = [
    `${stem(base, 2)}_1`,
    `${stem(base, 2)}_2`,
    `${stem(base, 2)}${year}`,
    `${stem(base, 8)}_cricket`,
    `${stem(base, 3)}_${digits(2)}`,
    `${stem(base, 4)}${digits(3)}`,
    `${stem(base, 3)}${digits(2)}`,
    `${stem(base, 5)}_${digits(3)}`,
    `${stem(base, 4)}_${digits(2)}x`,
    `${stem(base, 6)}${digits(4)}`,
    `${stem(base, 7)}_${digits(5)}`,
  ]
  const out: string[] = []
  for (const c of raw) {
    if (c !== base && USERNAME_RE.test(c) && !out.includes(c)) out.push(c)
    if (out.length >= max) break
  }
  return out
}
